import { APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/applicationsActionType';

export const INITIAL_STATE = {
    loaded: false,
    householdCaseId: null,
    entities: {},
    historicalApplications: null,
    historicalMigration: {
        migrated: null,
        ticketId: null,
        referenceId: null,
        encryptedTicketId: null
    },
    errorMessage: ''
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case APPLICATIONS_ACTION_TYPES.SET_APPLICATIONS: {
            return {
                ...state,
                loaded: true,
                householdCaseId: action.applications.householdCaseId,
                entities: action.applications,
                historicalApplications: null,
                historicalMigration: {
                    migrated: null,
                    ticketId: null,
                    referenceId: null,
                    encryptedTicketId: null
                },
                errorMessage: ''
            };
        }
        case APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS: {
            const prevMigration = state.historicalMigration || {
                migrated: null,
                ticketId: null,
                referenceId: null,
                encryptedTicketId: null
            };
            const nextApplications =
                action.historicalApplications !== undefined
                    ? action.historicalApplications
                    : state.historicalApplications;
            return {
                ...state,
                loaded: true,
                historicalApplications: nextApplications,
                historicalMigration: {
                    migrated: action.migrated !== undefined ? action.migrated : prevMigration.migrated,
                    ticketId: action.ticketId !== undefined ? action.ticketId : prevMigration.ticketId,
                    referenceId: action.referenceId !== undefined ? action.referenceId : prevMigration.referenceId,
                    encryptedTicketId: action.encryptedTicketId !== undefined ? action.encryptedTicketId : prevMigration.encryptedTicketId
                },
                errorMessage: ''
            };
        }
        case APPLICATIONS_ACTION_TYPES.GET_APPLICATIONS_ERROR: {
            return {
                ...state,
                errorMessage: action.payload
            };
        }
        case APPLICATIONS_ACTION_TYPES.GET_HISTORICAL_APPLICATIONS_ERROR: {
            return {
                ...state,
                errorMessage: action.payload
            };
        }
        default:
            return state;
    }
};